import ApiClient, { handleApiCall } from "../api";

/** Filter metadata read — no global loader; failures are handled in UI. */
export const getFilter = (entity: any, store_id?: any) =>
  ApiClient.get(
    `/filters?entity=${encodeURIComponent(entity)}${store_id ? `&store_id=${encodeURIComponent(String(store_id))}` : ""}`
  );

export const applyFilter = (postPayload) => handleApiCall("post", `/filters`, postPayload);